<template>
  <v-row>
    <v-col
        :xl="columnSizes.areaCode.lg"
        :lg="columnSizes.areaCode.lg"
        :md="columnSizes.areaCode.md"
        :sm="columnSizes.areaCode.sm"
        :cols="columnSizes.areaCode.xs"
    >
      <child-dynamic-element
          :formName="formName"
          :element="{
            type: 'SingleSelect',
            identifier: ids.areaCode,
            name: ids.areaCode,
            ...areaCode
          }"
          v-model="areaCodeValue"
          :optional="!required && phoneValue.length <= 0"
          :required="required || phoneValue.length > 0"
      />
    </v-col>

    <v-col
        :xl="columnSizes.phone.lg"
        :lg="columnSizes.phone.lg"
        :md="columnSizes.phone.md"
        :sm="columnSizes.phone.sm"
        :cols="columnSizes.phone.xs"
    >
      <child-dynamic-element
          :formName="formName"
          :element="{
            type: 'Text',
            identifier: ids.phone,
            ...phone
          }"
          v-model="phoneValue"
          :optional="!required && areaCodeValue.length <= 0"
          :required="required || areaCodeValue.length > 0"
      />
    </v-col>
  </v-row>
</template>

<script>
import {DynamicElement, isRequired} from "formvue-json";

export default {
  name: "SdsTelephone",
  components: {
    "child-dynamic-element": DynamicElement,
  },
  props: {
    validators: {
      type: Array,
      default: () => []
    },
    properties: {
      type: Object | Array,
      required: true,
    },
    formName: {
      type: String,
      required: true,
    },
    identifier: {
      type: String,
    },
    defaultValue: {
      type: String | Number
    }
  },
  data() {
    return {
      areaCodeValue: '',
      phoneValue: ''
    }
  },
  computed: {
    areaCode() {
      return this.requiredIf(this.mixinRequired(this.properties.areaCode), this.ids.phone);
    },
    phone() {
      return this.requiredIf(this.mixinRequired(this.properties.phone), this.ids.areaCode);
    },
    columnSizes() {
      return {
        areaCode: this.calcColumnSizes(this.areaCode),
        phone: this.calcColumnSizes(this.phone),
      }
    },
    ids() {
      return {
        areaCode: this.identifier + '_areaCode',
        phone: this.identifier + '_phone'
      };
    },
    value() {
      return this.areaCodeValue.replaceAll(/\s/g, '') + ' ' + this.phoneValue;
    },
    required() {
      return isRequired(this.properties);
    }
  },
  watch: {
    value(value) {
      this.$store.commit("updateInputValue", {
        key: this.identifier,
        value: value
      });
      this.$emit('input', value);
    }
  },
  created() {
    const storeValue = this.$store.getters.getCurrentModel.phone.value;

    if (storeValue) {
      this.acceptValue(String(storeValue));
      return;
    }

    if (!this.defaultValue) {
      const areaCodeDefaultValue = this.properties.areaCode.defaultValue;

      this.$store.commit("updateInputValue", {
        key: this.ids.areaCode,
        value: this.areaCodeValue = areaCodeDefaultValue
      });

      return;
    }

    this.acceptValue(String(this.defaultValue));
  },
  methods: {
    acceptValue(value) {
      const [areaCode, ...rest] = value.split(/\s/);
      if (!areaCode.startsWith('+')) return;

      this.$store.commit("updateInputValue", {
        key: this.ids.areaCode,
        value: this.areaCodeValue = areaCode
      });

      this.$store.commit("updateInputValue", {
        key: this.ids.phone,
        value: this.phoneValue = rest.join(' ')
      });
    },
    calcColumnSizes(element) {
      const validSizeOrFullWidth = (sizeKey) => {
        const defaultSize = 12; // 12 columns the entire container

        const gridColumnConfigObj =
            element.properties.gridColumnClassAutoConfiguration;
        if (!gridColumnConfigObj) return defaultSize;

        const viewportsObj = gridColumnConfigObj.viewPorts;
        if (!viewportsObj) return defaultSize;

        const sizeObj = viewportsObj[sizeKey];
        if (!sizeObj) return defaultSize;

        const size = sizeObj.numbersOfColumnsToUse;
        if (!size || isNaN(size) || size < 1 || size > 12) {
          return defaultSize;
        }
        return size;
      };

      if (typeof element.properties === "object") {
        return {
          lg: validSizeOrFullWidth("lg"),
          md: validSizeOrFullWidth("md"),
          sm: validSizeOrFullWidth("sm"),
          xs: validSizeOrFullWidth("xs"),
        };
      }

      return {
        lg: 12,
        md: 12,
        sm: 12,
        xs: 12,
      };
    },
    mixinRequired(obj) {
      if (!this.required) return obj;

      const mixed = structuredClone(obj);
      const properties = mixed.properties ?? {};

      const fluidAdditionalAttributes = properties.fluidAdditionalAttributes ?? {};

      fluidAdditionalAttributes.required = 'required';

      properties.fluidAdditionalAttributes = fluidAdditionalAttributes;

      const validationErrorMessages = properties.validationErrorMessages ?? [];

      validationErrorMessages.push({
        code: 1221560910,
        message: 'erforderlich'
      }, {
        code: 1221560718,
        message: 'erforderlich'
      }, {
        code: 1347992400,
        message: 'erforderlich'
      }, {
        code: 1347992453,
        message: 'erforderlich'
      });

      properties.validationErrorMessages = validationErrorMessages;

      mixed.properties = properties;

      const validators = mixed.validators ?? [];

      validators.push({
        code: 1221560910,
        errorMessage: "erforderlich",
        identifier: "NotEmpty",
      });

      mixed.validators = validators;

      return mixed;
    },
    requiredIf(obj, ref) {
      const validators = obj.validators ?? [];

      validators.push({
        code: 1695029287,
        errorMessage: "erforderlich",
        identifier: "RequiredIf",
        type: "required",
        options: {
          ifCondition: `NotEmpty:${ref}`
        }
      })

      obj.validators = validators;

      const properties = obj.properties ?? {};
      const validationErrorMessages = properties.validationErrorMessages ?? [];

      validationErrorMessages.push({
        code: 1695029287,
        message: 'erforderlich'
      })

      properties.validationErrorMessages = validationErrorMessages;
      obj.properties = properties;

      return obj;
    }
  },
};
</script>
